;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.services')
    .service('AppAccessService', AppAccessService)

  AppAccessService.$inject = [
    // Angular
    '$http', '$q',
    // Libs
    // Managers
    'UserManager',
    // Services
    // Const
    'accessibleApps', 'urls'
    // Resolved
  ]

  function AppAccessService (// Angular
    $http, $q,
    // Libs
    // Managers
    UserManager,
    // Services
    // Const
    accessibleApps, urls
    // Resolved
  ) {
    var self = this

    _.extend(self, {
      // Public Attributes
      accesses: [],
      companyRightsFetched: false,
      deferred: $q.defer(),
      // Public Method
      userHasAccessTo: userHasAccessTo,
      hasAccessTo: hasAccessTo,
      companyHasAccessToMultiple: companyHasAccessToMultiple,
      getCompanyRights: getCompanyRights
    })

    self.promise = self.deferred.promise
    function hasAccessTo (app) {
      return $http.get(urls.api + '/zenlabs/companies/rights').then(function (data) {
        if (data.data) {
          var apps = _.map(data.data.apps, window.btoa)
          if (_.includes(apps, accessibleApps[app])) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }

    function companyHasAccessToMultiple () {
      self.companyRightsFetched = true
      return $http.get(urls.api + '/zenlabs/companies/rights').then(function (data) {
        if (data.data) {
          const currentApps = _.map(data.data.apps, window.btoa)
          const array = []
          Object.keys(accessibleApps).forEach((key) => {
            if (_.includes(currentApps, accessibleApps[key])) {
              array.push({ appName: key, hasAccess: true })
            } else {
              array.push({ appName: key, hasAccess: false })
            }
          })
          self.accesses = [...array]
          self.deferred.resolve(array)
          return array
        } else {
          return []
        }
      })
    }

    // When you want to access company rights that have already been fetched
    function getCompanyRights () {
      if (self.companyRightsFetched) {
        return self.promise.then(function (companyAccesses) {
          return companyAccesses
        })
      } else {
        companyHasAccessToMultiple()
        return self.promise.then(function (companyAccesses) {
          return companyAccesses
        })
      }
    }

    function userHasAccessTo (app) {
      return UserManager.getProfile().then(function (user) {
        if (user.applicationForCompany) {
          const apps = user.applicationForCompany.map(function (p) {
            return window.btoa(p.application._id)
          })
          if (apps.includes(accessibleApps[app])) {
            return true
          } else {
            return false
            // TODO MODAL
          }
        } else {
          return false
        }
      })
    }
  }
})(window.angular, window._)
